const FETCHING_SETS = 'FETCHING_SETS'
const FETCHING_SETS_SUCCESS = 'FETCHING_SETS_SUCCESS'
const FETCHING_SETS_ERROR = 'FETCHING_SETS_ERROR'
const MS_SET_ACTIVE_SET = 'MS_SET_ACTIVE_SET'
const MS_SET_ITEM_FILTER = 'MS_SET_ITEM_FILTER'
const MS_REMOVE_ITEM_FILTER = 'MS_REMOVE_ITEM_FILTER'
const MS_FETCHING_ITEMS = 'MS_FETCHING_ITEMS'
const MS_FETCHING_ITEMS_SUCCESS = 'MS_FETCHING_ITEMS_SUCCESS'
const MS_FETCHING_ITEMS_ERROR = 'MS_FETCHING_ITEMS_ERROR'
const MS_FETCHING_NODES = 'MS_FETCHING_NODES'
const MS_FETCHING_NODES_SUCCESS = 'MS_FETCHING_NODES_SUCCESS'
const MS_FETCHING_NODES_ERROR = 'MS_FETCHING_NODES_ERROR'

export function fetchingSets() {
  return {
    type: FETCHING_SETS
  }
}

export function fetchingSetsSuccess (sets) {
  return {
    type: FETCHING_SETS_SUCCESS,
    sets,
  }
}

export function fetchingSetsError (error) {
  return {
    type: FETCHING_SETS_ERROR,
    error,
  }
}

export function setActiveSet (setId) {
  return {
    type: MS_SET_ACTIVE_SET,
    activeSet: setId,
  }
}

export function setItemFilter (filterBy, filterString) {
  return {
    type: MS_SET_ITEM_FILTER,
    filterBy,
    filterString,
  }
}

export function removeItemFilter (filterBy) {
  return {
    type: MS_REMOVE_ITEM_FILTER,
    filterBy,
  }
}

export function fetchingItems() {
  return {
    type: MS_FETCHING_ITEMS,
  }
}

export function fetchingItemsSuccess (items) {
  return {
    type: MS_FETCHING_ITEMS_SUCCESS,
    items,
  }
}

export function fetchingItemsError (error) {
  return {
    type: MS_FETCHING_ITEMS_ERROR,
    error,
  }
}

export function fetchingNodes() {
  return {
    type: MS_FETCHING_NODES,
  }
}

export function fetchingNodesSuccess (nodes) {
  return {
    type: MS_FETCHING_NODES_SUCCESS,
    nodes,
  }
}

export function fetchingNodesError (error) {
  return {
    type: MS_FETCHING_NODES_ERROR,
    error,
  }
}

const initialState = {
  isFetchingSets: false,
  fetchingSetsError: '',
  sets: null,
  activeSet: '',
  filters: {
    ContentType: '',
    ItemType: '',
    Name: '',
    QuestionText: '',
    Code: '',
    Node: '',
  },
  isFetchingItems: false,
  fetchingItemsError: '',
  items: null,
  isFetchingNodes: false,
  fetchingNodesError: '',
  nodes: null,
}

export function manageSets (state = initialState, action) {
  switch (action.type) {
    case FETCHING_SETS :
      return {
        ...state,
        isFetchingSets: true,
      }
    case FETCHING_SETS_SUCCESS :
      return {
        ...state,
        isFetchingSets: false,
        sets: action.sets,
      }
    case FETCHING_SETS_ERROR :
      return {
        ...state,
        isFetchingSets: false,
        sets: action.sets,
      }
    case MS_SET_ACTIVE_SET :
      return {
        ...state,
        activeSet: action.activeSet,
      }
    case MS_SET_ITEM_FILTER :
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterBy]: action.filterString,
        }
      }
    case MS_REMOVE_ITEM_FILTER :
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterBy]: '',
        }
      }
    case MS_FETCHING_ITEMS :
      return {
        ...state,
        isFetchingItems: true,
      }
    case MS_FETCHING_ITEMS_SUCCESS :
      return {
        ...state,
        isFetchingItems: false,
        items: action.items,
      }
    case MS_FETCHING_ITEMS_ERROR :
      return {
        ...state,
        isFetchingItems: false,
        fetchingItemsError: action.error,
      }
    case MS_FETCHING_NODES :
      return {
        ...state,
        isFetchingNodes: true,
      }
    case MS_FETCHING_NODES_SUCCESS :
      return {
        ...state,
        isFetchingNodes: false,
        nodes: action.nodes,
      }
    case MS_FETCHING_NODES_ERROR :
      return {
        ...state,
        isFetchingNodes: false,
        fetchingNodesError: action.error,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/manageSets.js